import { TableMap } from '../table-map';
export function pointsAtCell($pos) {
  return $pos.parent.type.spec.tableRole === 'row' && $pos.nodeAfter;
}
export function cellNear($pos) {
  for (var after = $pos.nodeAfter, pos = $pos.pos; after; after = after.firstChild, pos++) {
    var role = after.type.spec.tableRole;
    if (role === 'cell' || role === 'header_cell') {
      return $pos.doc.resolve(pos);
    }
  }
  for (var before = $pos.nodeBefore, _pos = $pos.pos; before; before = before.lastChild, _pos--) {
    var _role = before.type.spec.tableRole;
    if (_role === 'cell' || _role === 'header_cell') {
      return $pos.doc.resolve(_pos - before.nodeSize);
    }
  }
  return null;
}
export function cellAround($pos) {
  for (var d = $pos.depth - 1; d > 0; d--) {
    if ($pos.node(d).type.spec.tableRole === 'row') {
      return $pos.node(0).resolve($pos.before(d + 1));
    }
  }
  return null;
}
export function nextCell($pos, axis, dir) {
  var start = $pos.start(-1);
  var map = TableMap.get($pos.node(-1));
  var moved = map.nextCell($pos.pos - start, axis, dir);
  return moved == null ? null : $pos.node(0).resolve(start + moved);
}